import { Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridStyledTagline = styling(Grid)((props) => ({
  display: "flex",
  height: "unset",
  padding: "40px 120px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "32px",
  alignSelf: "stretch",
  backgroundImage: props.backgroundImage
    ? `
    radial-gradient(circle at 90.8854% 49.9609%, rgba(243,167,143,0.25) 0%, rgba(243,167,143,0) 35%),
    radial-gradient(circle at 94.3538% 89.6158%, rgba(243,167,143,0.25) 0%, rgba(243,167,143,0) 40%),
    radial-gradient(circle at 6.5039% 88.0371%, rgba(196,195,193,0.25) 0%, rgba(196,195,193,0) 50%),
    radial-gradient(circle at 6.1654% 12.6172%, rgba(88,88,87,0.3) 0%, rgba(88,88,87,0) 70%),
    radial-gradient(circle at 93.6865% 11.4258%, rgba(128,21,232,0.25) 0%, rgba(128,21,232,0) 70%),
    radial-gradient(circle at 48.9014% 49.5215%, rgba(34,34,34,0.28) 0%, rgba(34,34,34,0.28) 100%),
    url(${props.backgroundImage})
  `
    : `
    radial-gradient(157.4% 100.15% at 18.33% 0%, rgba(255,255,255,0.2) 25.73%, rgba(81,42,204,0.2) 58.17%, rgba(255,255,255,0.2) 100%),
    #FFF
  `,

  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
    height: "100%",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 16px",
    alignItems: "flex-start",
  },
}));

export const GridTagline = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: "24px",
  width: "100%",

  [props.theme.breakpoints.down("tablet")]: {
    alignItems: "center",
  },
}));

export const TaglineSubtitle = styling(Typography)((props) => ({
  color: "#FFF",
  fontFamily: "Inter",
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "30px",
  letterSpacing: "0.03px",
  textAlign: "center",
  maxWidth: "748px",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "620px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "unset",
    fontSize: "16px",
    lineHeight: "22.4px",
    textAlign: "left",
  },
}));
